import { type CompanyConfig, TimeFormat } from '../interface';

export const OcadoConfig: CompanyConfig = {
  id: '10d2b4a2-9c0b-4394-ba3f-98e70d2bed71',
  lang: 'en',
  langs: ['en'],
  name: 'Ocado',
  nameSecondary: 'Ocado',
  currency: '$',
  currencyCode: 'USD',
  officialName: 'Ocado',
  email: 'support@ocado.com',
  feedbackEmail: 'support@ocado.com',
  phonePlaceholder: '+44',
  defaultPhoneCode: '+44',
  ageRestricted: 18,
  timeZone: 'Europe/London',
  minimalOrderFeeThreshold: 700,
  canonical: '',
  defaultVolumeDisplay: '1x',
  countryCode: 'GB',
  warehouse: {
    default: 'OCADO',
    minimalOrderFeeWarehouseCodes: [],
    location: { lat: 51.530807618759574, lng: -0.15458534946287017 },
  },
  map: {
    center: { lat: 51.530807618759574, lng: -0.15458534946287017 },
    zoom: 12,
  },
  paymentMethods: ['gpay', 'applepay', 'visa', 'mc', 'jcb', 'amex', 'cash'],
  availablePaymentMethods: ['stripe'],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
  },
  referral: {
    code: '',
    discount: '',
    minBasket: '',
    downloadAppLink: '',
  },
  appStoreUrl: {
    ios: '',
    android: '',
  },
  apis: {},
  license: {
    name: 'Ocado',
    numberPrinary: '',
  },
};
